import { render, staticRenderFns } from "./informationForm.vue?vue&type=template&id=4bc04ba8&scoped=true"
import script from "./informationForm.vue?vue&type=script&lang=js"
export * from "./informationForm.vue?vue&type=script&lang=js"
import style0 from "./informationForm.vue?vue&type=style&index=0&id=4bc04ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc04ba8",
  null
  
)

export default component.exports